




















































import VatsAPI from '@/Shared/VatsAPI';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import { formatDate } from '@/Shared/Filters';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import mixins from 'vue-typed-mixins';

const component = mixins(LocationBasedMixin).extend({
    async beforeMount() {
        await this.loadData(this.location);
    },
    data() {
        return {
            holidays: [] as Date[],
            blackoutDays: [] as Date[],
            blackoutDate: null as Date | null,
            validationErrors: {} as { [key: string]: string[] },
            loading: false
        };
    },
    methods: {
        async addBlackoutDay() {
            try {
                if (!this.blackoutDate) {
                    this.validationErrors = {
                        blackoutDate: [this.$t('admin.hearingBlackoutDates.noDateError').toString()]
                    };
                    return;
                }

                this.loading = true;
                await VatsAPI.post(`/${this.location}/Hearings/BlackoutDates`, this.blackoutDate);

                this.validationErrors = {};
                this.blackoutDays.push(this.blackoutDate);
                this.blackoutDate = null;
                this.blackoutDays.sort((a, b) => a.getTime() - b.getTime());
            }
            catch (e) {
                this.validationErrors = getValidationErrors(e.response);
                throw e;
            }
            finally {
                this.loading = false;
            }
        },
        async removeBlackoutDay(blackoutDate: Date) {
            this.loading = true;
            try {
                await VatsAPI.delete(`/${this.location}/Hearings/BlackoutDates`, { data: blackoutDate });
                const blackoutDateTime = blackoutDate.getTime();
                this.blackoutDays = this.blackoutDays.filter(date => date.getTime() !== blackoutDateTime);
            }
            finally {
                this.loading = false;
            }
        },
        async loadData(location: string) {
            this.loading = true;
            const blackoutDaysRequest = VatsAPI.get<string[]>(`/${location}/Hearings/BlackoutDates`);
            const holidaysRequest = VatsAPI.get<string[]>(`/${location}/Hearings/Holidays`);
            this.blackoutDays = (await blackoutDaysRequest).data.map(date => new Date(Date.parse(date)));
            this.holidays = (await holidaysRequest).data.map(date => new Date(Date.parse(date)));
            this.loading = false;
        },
        async locationChanged(newLocation: string) {
            this.loadData(newLocation);
        }
    },
    computed: {
        blackoutDateFormatted(): string | null {
            return formatDate(this.blackoutDate);
        }
    }
});

export default component;
